module.exports = __webpack_public_path__ + "img/engravingSymbols.7b3053b.jpg";